import React, {Component} from 'react';
import {Map, TileLayer, Marker} from 'react-leaflet';
import L from 'leaflet';

const iconPerson = new L.Icon({
  iconUrl: '/car.png',
  iconRetinaUrl: '/car.png',
  iconSize: new L.Point(60, 75),
  className: 'leaflet-icon',
});

export default class MapTrackDriver extends Component<{
  position: any;
  zoom: number;
}> {
  componentDidMount() {}

  render() {
    return (
      <Map center={this.props.position} zoom={this.props.zoom}>
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={this.props.position} icon={iconPerson}></Marker>
      </Map>
    );
  }
}
